<template>
  <div class="row mb-3">
    <div class="col job-tabs">
      <div class="mb-4 nav nav-tabs nav-fill">
        <div :class="[jobTabStep === 1 ? 'active' : '']" class="nav-item nav-link pointer"
             @click="setJobTabStep(1)"
        >
          Addresses
        </div>
        <div :class="[jobTabStep === 2 ? 'active' : '']" class="nav-item nav-link pointer"
             @click="setJobTabStep(2)"
        >
          Location details
        </div>
        <div :class="[jobTabStep === 3 ? 'active' : '']" class="nav-item nav-link pointer"
             @click="setJobTabStep(3)"
        >
          Movers & Trucks
        </div>
        <div v-if="$_can('jobs.fee.change')" :class="[jobTabStep === 6 ? 'active' : '']" class="nav-item nav-link pointer"
             @click="setJobTabStep(6)"
        >
          Fees & Percentages
        </div>
        <div v-if="plans.length && $_can('jobs.plans.index')" :class="[jobTabStep === 5 ? 'active' : '']" class="nav-item nav-link pointer"
             @click="setJobTabStep(5)"
        >
          Plans
        </div>
        <div :class="[jobTabStep === 4 ? 'active' : '']" class="nav-item nav-link pointer"
             @click="setJobTabStep(4)" v-if="$_can('jobs.logs.index')"
        >
          Log
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    jobTabStep: {
      type: Number,
      default: 1,
    },
    plans: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    setJobTabStep(num) {
      this.$emit('jobTabStep', num);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/jobs/JobsTabs.vue